import { createContext } from 'react';
import type { Dispatch } from 'redux';

export const DispatchContext = createContext<Dispatch<any> | undefined>(undefined);
